import { render } from "./discount-attachment.vue?vue&type=template&id=400bded2"
import script from "./discount-attachment.vue?vue&type=script&lang=js"
export * from "./discount-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__